export enum DimensionsUnitsEnum {
  MM = 'mm',
  CM = 'cm',
}
